module.exports = "https://asset.exam-sp.com/release/edm-score/webapp/img/F0015392_banner_web.b3973dc1.png";